export default __webpack_public_path__ + "static/media/BoomDeployed.40c85d1d.jpg";